import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import { auth } from "@/firebase"


let API_URL =
  window.location.hostname === 'app.lwyr.ca'
    ? 'https://api.lwyr.ca'
    //: 'http://localhost:3000'
    :`http://${window.location.hostname}:3000`











const routes = [



  // The Catch-all Route
  { 
    path: '/:pathMatch(.*)*', 
    name: 'NotFound', 
   component: () =>
      import(/* webpackChunkName: "reader" */ "../views/404.vue"),
  },











  {
    path: "/",
    name: "home",
    component: HomeView,
  },

  {
    path: "/daily", // 
    name: "daily",
    component: () =>
      import(/* webpackChunkName: "reader" */ "../views/DailyView.vue"),
  },
  {
    path: "/trending", // 
    name: "trending",
    component: () =>
      import(/* webpackChunkName: "reader" */ "../views/TrendingView.vue"),
  },
  {
    path: "/picks", // 
    name: "picks",
    component: () =>
      import(/* webpackChunkName: "reader" */ "../views/PicksView.vue"),
  },





  {
    path: "/articles", // 
    name: "articles",
    component: () =>
      import(/* webpackChunkName: "reader" */ "../views/ArticlesView.vue"),
  },
  

  {
    //path: "/journals", // 
    path: '/journals/:journal',
    name: "journals",
    component: () =>
      import(/* webpackChunkName: "reader" */ "../views/JournalsView.vue"),
  },

  {
    path: "/journal/:id", // ← add ":id" to make it dynamic
    name: "journal",
    component: () =>
      import(/* webpackChunkName: "reader" */ "../views/JournalView.vue"),
  },



  {
    path: "/search", // 
    name: "search",
    component: () =>
      import(/* webpackChunkName: "reader" */ "../views/SearchView.vue"),
  }, 

  {
    path: "/history", // 
    name: "history",
    component: () =>
      import(/* webpackChunkName: "reader" */ "../views/HistoryView.vue"),
  },
  {
    path: "/favorites", // 
    name: "favorites",
    component: () =>
      import(/* webpackChunkName: "reader" */ "../views/FavoritesView.vue"),
  },
  {
    path: "/settings", // 
    name: "settings",
    component: () =>
      import(/* webpackChunkName: "reader" */ "../views/SettingsView.vue"),
  },
  {
    path: "/test", // 
    name: "test",
    component: () =>
      import(/* webpackChunkName: "reader" */ "../views/test.vue"),
  },

  {
    path: "/r/:id", // 
    name: "r",
    component: () =>
      import(/* webpackChunkName: "reader" */ "../views/ReaderTestView.vue"),
  },


 

  {
    path: "/reader/:id", // ← add ":id" to make it dynamic
    name: "reader",
    component: () =>
      import(/* webpackChunkName: "reader" */ "../views/ReaderView.vue"),
  },

  {
    path: "/source/:id", // ← add ":id" to make it dynamic
    name: "source",
    component: () =>
      import(/* webpackChunkName: "reader" */ "../views/SourceView.vue"),
  },










  {
    path: "/sources", // 
    name: "sources",
    component: () =>
      import(/* webpackChunkName: "reader" */ "../views/SourcesView.vue"),
  },




  
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },

   








  {
    path: '/admin',
    component: () =>
      import(/* webpackChunkName: "test" */ "../views/AdminView.vue"),
      meta: { requiresAdmin: true }
  }






];


 

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    //return { top: 0 };
        const el = document.querySelector('.content')
    if (el) el.scrollTop = 0
  },

  /* If you want back button restores scroll (like Twitter):
  scrollBehavior(to, from, savedPosition) {
  const el = document.querySelector('.content')
  if (!el) return

  if (savedPosition) {
    el.scrollTop = savedPosition.top
  } else {
    el.scrollTop = 0
  }
}

  */
});




function getCurrentUser() {
  return new Promise((resolve) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      unsubscribe()
      resolve(user)
    })
  })
}

router.beforeEach(async (to, from, next) => {
  if (!to.meta.requiresAdmin) return next()

  const user = await getCurrentUser()
  if (!user) return next('/')

  try {
    const token = await user.getIdToken()
    const res = await fetch(`${API_URL}/api/check-admin`, {
      headers: { Authorization: `Bearer ${token}` }
    })

    const data = await res.json()
    if (!data.isAdmin) return next('/')
  } catch {
    return next('/')
  }

  next()
})














 








export default router;
